import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const LegalRequirements = () => {
  const location = useLocation();

  const legalNoticeRef = useRef<HTMLDivElement>(null);
  const privacyPolicyRef = useRef<HTMLDivElement>(null);
  const disclaimerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const hash = location.hash.replace('#', '');
    if (hash) {
      scrollToSection(hash);
    }
  }, [location.hash]);

  const scrollToSection = (section: string) => {
    let ref;
    switch (section) {
      case 'legal-notice':
        ref = legalNoticeRef;
        break;
      case 'privacy-policy':
        ref = privacyPolicyRef;
        break;
      case 'disclaimer':
        ref = disclaimerRef;
        break;
    }
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div
      className="l-legal-requirements"
      style={{
        padding: '24px',
        overflowY: 'auto',
        backgroundColor: '#fff',
        height: '100%',
        color: '#000',
        fontSize: '14px',
        lineHeight: '1.5',
      }}
    >
      <h2 style={{ color: '#45606B', marginBottom: '32px' }}>
        Legal requirements DNAwiz
      </h2>

      <div ref={legalNoticeRef} style={{ marginBottom: '40px' }}>
        <h3 style={{ color: '#45606B' }}>Legal notice</h3>
        <p>
          bio.logis digital health GmbH
          <br />
          Altenhöferallee 3<br />
          60438 Frankfurt am Main
          <br />
          Germany
          <br />
          Phone: +49 69 34871161
          <br />
          Email: info@biologis.eu
        </p>
        <p>
          Managing Director:
          <br />
          Prof. Dr. Daniela Steinberger
          <br />
          Corporate Seat: Frankfurt am Main
          <br />
          Court District: Frankfurt am Main
          <br />
          Company Registration Number: HRB 12206
          <br />
          VAT Number: DE-340703588
        </p>
        <p>
          Responsible for content according to §5 DDG: Prof. Dr. Daniela
          Steinberger (address as above)
          <br />
          The contents of this web page are protected by copyright that is they
          only can be copied, changed or otherwise saved electronically with the
          consent of the particular author.
        </p>
      </div>

      <div ref={privacyPolicyRef} style={{ marginBottom: '40px' }}>
        <h3 style={{ color: '#45606B' }}>Privacy Policy</h3>
        <p>This privacy policy applies to data processing by</p>
        <p>
          bio.logis digital health GmbH
          <br />
          Altenhöferallee 3<br />
          60438 Frankfurt am Main, Germany
          <br />
          Phone: +49 69 34871161
          <br />
          Email: info@biologis.eu
        </p>
        <h4 style={{ marginTop: '24px' }}>Data Protection Officer</h4>
        <p>
          Mike Peter
          <br />
          mpP Group | yourprivacyfirst
          <br />
          Data Protection Expert
          <br />
          Managing Director and Owner Mike Peter
          <br />
          Landeckring 19
          <br />
          76831 Impflingen, Germany
          <br />
          Phone: +49 6341 6731696
          <br />
          Email: hello@yourprivacyfirst.de
        </p>
        <h4 style={{ marginTop: '24px' }}>Collection of personal data</h4>
        <p>
          <strong>a) Visiting the website</strong>
          <br />
          When visiting https://dnawiz.org/ your browser will automatically send
          your IP address as well as day and time of your visit to our server.
          This information will be stored temporarily in a so called logfile and
          will be erased automatically. The purpose is to ensure a quick and
          smooth connection as well as a comfortable use of the website.
          <br />
          This data will not be used for any purpose other than described above.
          The legal basis of this processing is art. 6, para. 1f EU-GDPR, our
          legitimate interest with regard to the purpose described above.
        </p>
        <p>
          <strong>b) Filling out the contact form</strong>
          <br />
          If you wish to get in contact with us send an email to
          info@biologis.eu or visit our website https://www.biologis.eu where
          you can use the contact form. You will have to enter a name, a valid
          email address and the corresponding subject of your inquiry. Further
          information is optional. We will use your email address to respond to
          your inquiry.
          <br />
          The processing is carried out pursuant to Article 6(1b) of the EU
          GDPR, insofar as it is required for the performance of a contract or
          for the implementation of pre-contractual measures requested by you.
          <br />
          Once your inquiry is concluded your data will be deleted, provided
          there is no requirement to keep your data arising from a consequential
          business relationship, transaction or any kind of legal obligation.
        </p>
        <h4 style={{ marginTop: '24px' }}>
          Transfer of personal data to third parties
        </h4>
        <p>
          Your personal data will under no circumstances be transferred or
          disclosed to a third party unless
        </p>
        <ul style={{ paddingLeft: '20px' }}>
          <li>you have given your explicit consent</li>
          <li>we are under a legal obligation to do so</li>
          <li>
            for the establishment, exercise or defense of legal claims assuming
            that there is no overriding, legitimate interest on your side
            contradicting a transfer
          </li>
          <li>
            for enabling a comfortable use of our website and embedding certain
            features (see Tools and Plugins)
          </li>
        </ul>
        <h4 style={{ marginTop: '24px' }}>Cookies</h4>
        <p>
          This website is using cookies to increase user friendliness. Cookies
          are small text files which are stored in your device´s browser. They
          can for example allow websites to store user preferences in order to
          react accordingly and enhance the user experience. Cookies do not
          enable us to identify you as an individual.
          <br />
          If you do not want your browser to accept cookies you can configure it
          accordingly in the browser´s settings.
        </p>
        <h4 style={{ marginTop: '24px' }}>
          Your rights with regard to personal data
        </h4>
        <p>You have the right to</p>
        <ul style={{ paddingLeft: '20px' }}>
          <li>
            inquire as to whether or not, to what extend and to what purpose we
            are processing your personal data (art. 15 EU-GDPR)
          </li>
          <li>
            demand the correction, adjustment or amendment of your personal data
            (art. 16 EU-GDPR)
          </li>
          <li>
            demand the erasure of your personal data (art. 17, EU-GDPR),
            provided that data processing is not required for
            <ul style={{ paddingLeft: '20px' }}>
              <li>
                exercising the right of freedom of expression and information
              </li>
              <li>compliance with a legal obligation</li>
              <li>reasons of public interest</li>
              <li>the establishment, exercise or defense of legal claims</li>
            </ul>
          </li>
          <li>
            demand a restriction of processing of your personal data, if
            <ul style={{ paddingLeft: '20px' }}>
              <li>the accuracy of the personal data is contested</li>
              <li>
                the processing is unlawful and you oppose the erasure of the
                personal data
              </li>
              <li>
                we no longer need the personal data for the purposes of the
                processing, but they are required by you for the establishment,
                exercise or defence of legal claims
              </li>
              <li>
                you have objected to processing pursuant to Article 21(1) and
                the verification whether the objection is based on legitimate
                grounds is pending
              </li>
            </ul>
          </li>
          <li>
            receive your personal data in structured, commonly used and
            machine-readable format (art. 20 EU-GDPR)
          </li>
          <li>
            object to the processing of your personal data (art. 21 EU-GDPR)
          </li>
          <li>
            withdraw you consent to the processing of your personal data (art. 7
            para. 3 EU-GDPR)
          </li>
        </ul>
        <p>
          If you would like to make use of any of the rights described above,
          please contact: https://www.biologis.eu and use contact form or write
          an email to info@biologis.eu
          <br />
          In addition, you have the right to lodge a complaint with a
          supervisory authority (art. 77 EU-GDPR).
        </p>
        <h4 style={{ marginTop: '24px' }}>Changes to the privacy policy</h4>
        <p>
          We reserve the right to change this privacy policy at any time,
          observing the applicable law. The current status is December 2025.
        </p>
      </div>

      <div ref={disclaimerRef} style={{ marginBottom: '40px' }}>
        <h3 style={{ color: '#45606B' }}>Disclaimer</h3>
        <p>
          The information on this website is not intended for diagnostic or
          medical decision-making purposes. One should not change health
          behaviour based on this information, but see a health care
          professional for advice.
        </p>
        <p>
          bio.logis digital health GmbH does not independently validate the
          submitted information and does not guarantee for the correctness,
          completeness, currency or reliability. Users must evaluate and verify
          the information carefully before relying on it. The use of this
          website and its content is at the sole risk of the user.
        </p>
      </div>
    </div>
  );
};

export default LegalRequirements;
